import React from "react";
import moment from "moment";
import i18n from 'i18n';
import { values } from "lodash";

import warningIcon from "../../../../../assets/images/icons/error.svg";
import errIcon from "../../../../../assets/images/icons/error2.svg";
import successIcon from "../../../../../assets/images/icons/success.svg";

let shortid = require("shortid");

Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export function getBooleanValue(params) {
    return (params.value === true || params.value === 'true') ? i18n.t('Active') : i18n.t('Passive');
}
export function getBool(params, params2) {
    return value || value2;
}

export function getBooleanValueCheckbox(params) {
    params.value = !!((params.value === true || params.value === 'true'));
    return <input type="checkbox" readOnly={true} checked={params.value} />;
}

export function getBooleanCheckbox(params) {
    params = !!((params === true || params === 'true'));
    return <input type="checkbox" readOnly={true} checked={params} />;
}

export function getDateTime(params) {
    return moment(params.value).format('MM/DD/YYYY HH:mm:ss');
}
export function getDate(params) {

    return params.value === null ? '' : moment(params.value).format('MM/DD/YYYY');
}
export function getDateFormat(params) {

    return params.value === null ? '' : moment(params.value).format('DD.MM.YYYY');
}
export function getCurrency(params) {
    return Number(params.value).toFixed(2);
}

export function getListItem(params, list) {
    if (list) {
        let cmbObject = list.filter(
            x => x.guid == params.value
        );
        return cmbObject.length > 0 && cmbObject[0].name ? cmbObject[0].name : params.value;
    } else {
        return params.value;
    }
}

export function uniqueIdentifier() {
    return shortid.generate();
}

export function getListItemParameter(params, list, parameter) {
    if (list) {
        let cmbObject = list.filter(
            x => x.guid == params.value
        );

        let opts = cmbObject[0];
        let param = opts != undefined ? opts[parameter] : "";
        return cmbObject.length > 0 && param ? param : params.value;
    } else {
        return params.value;
    }
}
export function getInitValue(item, value) {
    return item && value || "";
}

export function intToDateFormat(record, inputInt) {
    if (!inputInt) return "";

    const inputStr = inputInt.toString();

    const year = inputStr.substring(0, 2);
    const month = inputStr.substring(2, 4);

    const formattedYear = (2000 + parseInt(year)).toString();
    const formattedMonth = (parseInt(month)).toString().padStart(2, '0');
    const formattedDay = "01";

    const formattedDate = `${formattedYear}-${formattedMonth}-${formattedDay}`;
    return formattedDate;
}

export function getInitValueTriple(item, value, value2) {
    return (item && value && value2) || "";
}
export function getInitValueBooleanTriple(item, value, value2) {
    return (item && value && value2) || false;
}
export function getInitValueBoolean(item, value) {
    return item && value || false;
}

export function getInitValueInteger(item, value) {
    return item && value || 0;
}

export function getInitValueNull(item, value) {

    return item && value || null;

}
export function getInitValueArray(item, value) {
    return item && value || [];
}

export function getInitValueDate(item, value, date) {
    return item && value || moment(new Date().addDays(date)).format('YYYY-MM-DD');
}

export function getTitleValue(thisPage, defaultValue) {
    if (thisPage.state.isDetail) {
        return thisPage.props.t(defaultValue);
    }
    return thisPage.state.isEdit ?
        thisPage.props.t("edit" + defaultValue[0].toUpperCase() + defaultValue.substring(1)) :
        thisPage.props.t("new" + defaultValue[0].toUpperCase() + defaultValue.substring(1));
}

export function getInvalid(errors, touched) {
    return (errors && touched) ? " is-invalid" : "";
}

export function getListMenu(params, list) {
    if (list) {
        let cmbObject = list.filter(
            x => x.guid == params.value
        );
        return cmbObject.length > 0 && cmbObject[0].pageName ? cmbObject[0].pageName : params.value;
    } else {
        return params.value;
    }
}
export function getMmyyDate(params) {
    return moment(params.value).format('MM/YYYY');
}

export function getTime(params) {
    return moment(params.value).format('HH:mm:ss');
}

export function getPercentageDisplay(value) {
    return "%" + value * 100
}

export function ignoreSixDigit(value) {
    return value.toString().slice(6)
}

export function currencyFormatter(currency, sign) {
    const [intPart, decPart] = currency.toFixed(2).split(".");
    const formattedInt = Number(intPart).toLocaleString("de-DE");
    return `${formattedInt},${decPart} ${sign}`;
  }
  
export function dotFormatter(value) {
    const [intPart, decPart] = value.toFixed(2).split(".");
    const formattedInt = Number(intPart).toLocaleString("de-DE");
    return `${formattedInt},${decPart}`;
  }

export function getNumberValueByDatetime() {
    return moment(new Date()).format('dMMyyyyhhMMss');
}
export function displayNone(value) {
    return value ? "none" : "inline-block"
}

export function padLeft(value, length, padChar) {
    const stringValue = value.toString();
    const padding = Array(length - stringValue.length + 1).join(padChar || '0');
    return padding + stringValue;
}

export function currencyFormatControl(param) {

    let regexp = /^\d+(?:\.\d{1,2})?$/;
    let checkCurrencyFormat;
    let amountControl;
    if (param !== null && param !== "" && param !== undefined) {
        checkCurrencyFormat = regexp.test(param);
        amountControl = parseFloat(param).toFixed(2);
        if (checkCurrencyFormat && amountControl <= 100) {
            return parseFloat(param).toFixed(2);
        }
        else {
            param = "0.00";
            return param;
        }
    }
}

export function getLinkPaymentErrorMessage(value) { 

    let apiError = value?.errorData;

    if (typeof apiError === "string") {
        try {
            apiError = JSON.parse(apiError);
        } catch (err) {
            console.error("Error parsing errorData JSON:", err);
            return "Bilinmeyen bir hata oluştu (parse error).";
        }
    }

    if (apiError) {
        const code = apiError.Code ?? "NoCode";
        const message = apiError.Message ?? apiError.Details ?? "NoMessage";
        const validationMessage = apiError.validationResults?.[0]?.ErrorMessage ?? "";

        const finalMessage = `${code} - ${message}`;
        return finalMessage;
    }
  

    if (value === null || value === "" || value.length === 0 || value.z === 0 || value.z === undefined && value.code === undefined && value.errorStatus === undefined) { return i18n.t("checkoutError") }
    if (value.a !== undefined && value.a === false && value.code === undefined) { return i18n.t("linkPaymentStockOutMessage") }
    if (value.p !== undefined && value.p !== "5" && value.code === undefined) { return i18n.t("morparaLinkPaymentStatusNotAvailable") }
    if (value.code !== undefined && value.code === "B0000") {
        return `${value.code} - ${i18n.t("paymentSuccessfull")}`;
    }
    
    if (value.code !== undefined && value.code !== "B0000") {
        return `${value.code} - ${i18n.t("paymentFail")}`;
    }
    if (value.errorStatus !== undefined &&  value.errorStatus === 500 ||  value.errorStatus === 401) { return i18n.t("linkPaymentErrorMessage") }
    if (value.errorStatus !== undefined &&   value.errorStatus === 400) { return i18n.t("linkPaymentBadRequestMessage") }
    
}

export function displayNoneInline(value) {
    return value ? "none" : "inline"
}

export function linkPaymentSetIcon(value) {
    if (value === null || value === "" || value.length === 0 || value.z === 0 || value.z === undefined && value.code === undefined && value.errorStatus === undefined ) { return warningIcon }
    if (value.p !== undefined || value.a !== undefined || value.a === false || value.p !== "5" && value.code === undefined) { return errIcon }
    if (value.code !== undefined && value.code === "B0000") { return successIcon }
    if (value.code !== undefined && value.code !== "B0000") { return warningIcon }
    if (value.errorStatus !== undefined &&  value.errorStatus === "500" ||  value.errorStatus === "401" || value.errorStatus === "400")   { return warningIcon } 

    return warningIcon;
}

export function linkPaymentIsSuccess(value) {
    if (value === null || value === "" || value.length === 0 || value.z === 0 || value.z === undefined && value.code === undefined && value.errorStatus === undefined ) { return false }
    if (value.p !== undefined || value.a !== undefined || value.a === false || value.p !== "5" && value.code === undefined) { return false }
    if (value.code !== undefined && value.code === "B0000") { return true }
    if (value.code !== undefined && value.code !== "B0000") { return false }
    if (value.errorStatus !== undefined &&  value.errorStatus === "500" ||  value.errorStatus === "401" || value.errorStatus === "400")   { return false } 

    return false;
}

export function linkPaymenSetMessage(value) {
    // if (value === null || value === "" || value.length === 0 || value.z === 0 || value.z === undefined) { return i18n.t("checkoutError") }
    // if (value.a === false) { return i18n.t("linkPaymentStockOutMessage") } 
    if (value.code !== undefined && value.code === "B0000") { return i18n.t("paymentResultSuccessMessage").format(value.orderId) }
    if (value.code !== undefined && value.code !== "B0000") { return `${value.code} - ${i18n.t("paymentResultFailMessage").format(value.message)}` }
}

export function setMessage(value) {
    return value?.htmlFormSuccess;
}

export function getListItemParameterExcelExport(value, list, parameter) {
    if (list) {
        const cmbObject = list.find(x => x.guid === value);        
        if (cmbObject) {
            return cmbObject[parameter] || value; 
        }
    }
    return value; 
}
